import React, { useState } from "react";
import { ContactsHeader } from "@/components/contacts/ContactsHeader";
import { ContactFormWrapper } from "@/components/contacts/ContactFormWrapper";
import { ContactsTableWrapper } from "@/components/contacts/ContactsTableWrapper";
import { useContacts } from "@/hooks/useContacts";
import type { Contact, ContactFormData } from "@/types/contact";

const Contacts = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingContact, setEditingContact] = useState<Contact | undefined>();
  const { contacts, isLoading, createContact, updateContact, deleteContact } =
    useContacts();

  const handleSubmit = (data: ContactFormData) => {
    if (editingContact) {
      updateContact.mutate({ ...editingContact, ...data });
    } else {
      createContact.mutate(data);
    }
    handleCloseForm();
  };

  const handleEdit = (contact: Contact) => {
    setEditingContact(contact);
    setIsFormOpen(true);
  };

  const handleDelete = (id: string) => {
    if (window.confirm("Tem certeza que deseja excluir este contato?")) {
      deleteContact.mutate(id);
    }
  };

  const handleCloseForm = () => {
    setIsFormOpen(false);
    setEditingContact(undefined);
  };

  return (
    <div className="space-y-4">
      <ContactsHeader onNewContact={() => setIsFormOpen(true)} />

      {isFormOpen ? (
        <ContactFormWrapper
          editingContact={editingContact}
          onSubmit={handleSubmit}
          onCancel={handleCloseForm}
        />
      ) : (
        <ContactsTableWrapper
          contacts={contacts}
          isLoading={isLoading}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      )}
    </div>
  );
};

export default Contacts;
